import React, { useState, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import config from '../utils/config';
import { useAuth } from '../utils/AuthContext/AuthContext';
import ProfessionalCard from "../components/Professionals/ProfessionalsCard";
import ProfessionFilter from "../components/Professionals/ProfessionFilter";
import ProfessionalDetail from "../components/Professionals/ProfessionalDetail";
import '../components/Professionals/Professionals.css'; 

import SearchSVG from "../assets/Search";
import AllSVG from "../assets/All"; 
import InspectorSVG from "../assets/Inspector"; 
import AttorneySVG from "../assets/Attorney"; 
import LenderSVG from "../assets/Lender"; 
import InsuranceSVG from "../assets/Insurance"; 
import CloseSVG from '../assets/Close';
import SurveyorSVG from '../assets/Surveyor';

export default function ProfessionalsPage() {
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const location = useLocation();
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedProfession, setSelectedProfession] = useState('all');
  const [selectedProfessional, setSelectedProfessional] = useState(null); 
  const [selectedDetailOption, setSelectedDetailOption] = React.useState('about');
  const [professionals, setProfessionals] = useState([]); 
  const [filteredProfessionals, setFilteredProfessionals] = useState([]);
  const { token } = useAuth(); 

  const totalProfessionals = filteredProfessionals.length; 

  const professionFilters = [
    { id: 'all', icon: <AllSVG width={isMobile ? 20 : 20} height={isMobile ? 20 : 20} />, label: isMobile ? 'All Pros' : 'All Pros' },
    { id: 'Inspector', icon: <InspectorSVG width={isMobile ? 23 : 30} height={isMobile ? 23 : 30} />, label: isMobile ? 'Inspector' : 'Inspector' },
    { id: 'Surveyor', icon: <SurveyorSVG width={isMobile ? 25 : 37} height={isMobile ? 26 : 40} fill='#000000'/>, label: isMobile ? 'Surveyor' : 'Surveyor' },  
    // { id: 'Attorney', icon: <AttorneySVG width={isMobile ? 23 : 30} height={isMobile ? 23 : 30} />, label: isMobile ? 'Attorney' : 'Real Estate Attorney' },
    { id: 'Lender', icon: <LenderSVG width={isMobile ? 23 : 30} height={isMobile ? 23 : 30} />, label: 'Lender' },
    // { id: 'Insurance', icon: <InsuranceSVG width={isMobile ? 23 : 30} height={isMobile ? 23 : 30} />, label: isMobile ? 'Insurance' : 'Home Insurance' },
  ];

  const handleCloseOverlay = () => {
    setSelectedProfessional(null);
  };

    // // When the component mounts, check if a filter was passed via state.
    useEffect(() => {
      if (location.state && location.state.selectedProfession) {
        setSelectedProfession(location.state.selectedProfession);
      }
    }, [location.state]);

    useEffect(() => {
      const query = searchQuery.toLowerCase();
      const filtered = professionals.filter(professional => {
        const address = professional.contact.address.toLowerCase();
        // Compare in a case-insensitive way
        const professionMatch =
          selectedProfession === 'all' ||
          professional.profession.toLowerCase() === selectedProfession.toLowerCase();
        return address.includes(query) && professionMatch;
      });
      setFilteredProfessionals(filtered);
    }, [selectedProfession, professionals, searchQuery]); 

  useEffect(() => {
    const fetchProfessionals = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${config.apiBaseUrl}/professionals`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        const data = await response.json();
        if (Array.isArray(data)) {
          setProfessionals(data);
          setFilteredProfessionals(data);
        } else {
          console.error('Fetched data is not an array:', data);
        }
      } catch (error) {
        console.error('Error fetching professionals:', error);
      }
    };

    fetchProfessionals();
  }, [token]);

  const handleContactClick = () => {
    setSelectedDetailOption('contact');
  };


  const handleSearch = () => {
    const query = searchQuery.toLowerCase();
    const filtered = professionals.filter(professional => {
      const address = professional.contact.address.toLowerCase();
      const professionMatch = selectedProfession === 'all' || professional.profession === selectedProfession;
      return address.includes(query) && professionMatch;
    });
    setFilteredProfessionals(filtered);
  };

  const handleProfessionFilterClick = (profession) => {
    setSelectedProfession(profession);
    const query = searchQuery.toLowerCase();
    const filtered = professionals.filter(professional => {
      const address = professional.contact.address.toLowerCase();
      const professionMatch = profession === 'all' || professional.profession === profession;
      return address.includes(query) && professionMatch;
    });
    setFilteredProfessionals(filtered);
  };

  console.log("Selected Professional:", selectedProfessional);
  

  return (
    <div className={`flex overflow-hidden flex-col pb-5 bg-neutral-50`}>
      <main className="self-center w-full px-2 md:px-4">
        <div className={`${isMobile ? 'flex flex-col' : 'inline-flex'} gap-5`}>
          <div
            className={`
              flex flex-col shadow-lg transition-all duration-300
              ${selectedProfessional && !isMobile ? 'md:w-[calc(100%-435px)]' : 'w-full'}
            `}
          >
            <div className="flex grow items-start mt-1 md:mt-0 ">
              <div className="flex overflow-hidden flex-col flex-1 shrink w-full bg-white rounded-lg basis-0 min-h-[863px] min-w-[240px] shadow-[-4px_4px_8px_rgba(221,221,221,0.14)]">
                <div className="flex justify-start overflow-x-scroll gap-3 items-center md:px-4 md:py-4 px-2 py-2 w-full">
                  {professionFilters.map(filter => (
                    <ProfessionFilter
                      key={filter.id}
                      icon={filter.icon}
                      label={filter.label}
                      selected={selectedProfession === filter.id}
                      onClick={() => handleProfessionFilterClick(filter.id)}
                      className="shrink-0"
                    />
                  ))}
                </div>
                <div className="flex flex-col mt-3 md:mt-8 w-full">
                  <div className="flex gap-9 items-center px-4 py-2 w-full text-base font-medium text-center text-zinc-500">
                    <div className="flex items-center self-stretch px-2 py-1 md:px-4 md:py-1.5 my-auto w-full bg-white rounded-xl border border-solid border-zinc-500">
                      <SearchSVG width={isMobile ? 20 : 20} height={isMobile ? 20 : 20}/>
                      <input 
                        type="text" 
                        placeholder="Search Location"
                        aria-label="Search Location"
                        className="bg-transparent border-none outline-none flex-1 px-2"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                      <button onClick={handleSearch} className="bg-shi-green text-white px-2 py-1 rounded-lg whitespace-nowrap">
                        Search
                      </button>
                    </div>
                  </div>
                  <div className="px-4 pt-2.5 w-full text-lg md:text-lg font-inter font-light text-black">
                    {professionFilters.id} Recommended Professionals <span className="text-zinc-500">({totalProfessionals})</span>
                  </div>
                </div>
                <div className={`grid grid-cols-1 ${selectedProfessional && !isMobile ? 'md:grid-cols-3' : 'md:grid-cols-4'} gap-4 px-4 py-2 md:px-2.5 mt-4 md:mt-8 w-full`}>
                  {filteredProfessionals.length === 0 ? (
                    <div>Coming Soon!</div>
                  ) : (
                    filteredProfessionals.map((professional, index) => (
                      <ProfessionalCard
                        key={index}
                        {...professional}
                        selected={selectedProfessional === professional}
                        onClick={() => setSelectedProfessional(professional) && setSelectedDetailOption('about')}
                        onContactClick={handleContactClick}
                      />
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>
          {!isMobile && selectedProfessional && (
            <div className="flex flex-col ml-1 w-[435px]">
              <ProfessionalDetail 
                professional={selectedProfessional}
                selectedDetailOption={selectedDetailOption}
                setSelectedDetailOption={setSelectedDetailOption}
                onContactClick={handleContactClick}
              />
            </div>
          )}
        </div>
      </main>
      {isMobile && selectedProfessional && (
        <div className="overlay" onClick={handleCloseOverlay}>
          <div className="professional-detail slide-up" onClick={(e) => e.stopPropagation()}>
            <button onClick={handleCloseOverlay} className="absolute top-4 right-4"><CloseSVG width={17} height={17}/></button>
            <ProfessionalDetail 
              professional={selectedProfessional}
              selectedDetailOption={selectedDetailOption}
              setSelectedDetailOption={setSelectedDetailOption}
              onContactClick={handleContactClick}
            />
          </div>
        </div>
      )}
    </div>
  );
};